/**
 * @generated SignedSource<<9627fa2aafef41bb20bea6b5258b94f5>>
 * @relayHash a28fc42ea6653f12be5a30a11af5dc0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5ebe1fceee5e2e21eb964959cab51d5a05dec7e313731928cfccaf6ee68f5726

import type { ConcreteRequest } from 'relay-runtime';
export type useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery$variables = Record<PropertyKey, never>;
export type useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery$data = {
  readonly paywallContentToDisable: {
    readonly deactivationIdentifier: string;
    readonly link: string | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
};
export type useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery = {
  response: useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery$data;
  variables: useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "contentType",
        "value": "whiteboard"
      }
    ],
    "concreteType": "PaywallContentSingle",
    "kind": "LinkedField",
    "name": "paywallContentToDisable",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "deactivationIdentifier"
      },
      {
        "kind": "ScalarField",
        "name": "link"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ],
    "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a28fc42ea6653f12be5a30a11af5dc0d",
    "id": "5ebe1fceee5e2e21eb964959cab51d5a05dec7e313731928cfccaf6ee68f5726",
    "metadata": {},
    "name": "useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery",
    "operationKind": "query",
    "text": "query useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
  }
};
})();

(node as any).hash = "6ee03621e25bbc769cda83bd42cb5765";

export default node;
